import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getBuildingDimensionFormatted } from '@/bundles/MeasurementUnits/helpers/format/getBuildingDimensionFormatted';

// A 0 dimension means "not set", so it reads as N/A like a missing one.
export const getBuildingDimensionLabel = (value: Nullable<number | string>): Nullable<string> => {
  return isValuePresent(value) && value !== 0 ? getBuildingDimensionFormatted(value) || null : null;
};

// Text form of BuildingDimensionLabels: "W x D" / "min - max", N/A for a missing first side.
export const getBuildingDimensionsLabel = (
  value1: Nullable<number | string>,
  value2: Nullable<number | string>,
  separator = '-'
): Nullable<string> => {
  if (!isValuePresent(value1) && !isValuePresent(value2)) {
    return null;
  }

  const first = getBuildingDimensionLabel(value1) ?? 'N/A';

  return isValuePresent(value2) ? `${first} ${separator} ${getBuildingDimensionLabel(value2) ?? 'N/A'}` : first;
};
